import { Events } from './events';

const IS_SCENE_DIRTY = 'supersplat:is-scene-dirty';

interface IsSceneDirtyQuery {
    type: typeof IS_SCENE_DIRTY;
}

interface IsSceneDirtyResponse {
    type: typeof IS_SCENE_DIRTY;
    result: boolean;
}

const isSceneDirtyQuery = (data: any): data is IsSceneDirtyQuery => {
    return (
        data &&
        typeof data === 'object' &&
        data.type === IS_SCENE_DIRTY
    );
};

const registerIframeApi = (events: Events) => {
    const existingDispose = (events as any)._iframeApiDispose as undefined | (() => void);
    if (existingDispose) {
        return existingDispose;
    }

    const onMessage = (event: MessageEvent) => {
        const source = event.source as Window | null;
        if (!source) {
            return;
        }

        if (isSceneDirtyQuery(event.data)) {
            const response: IsSceneDirtyResponse = {
                type: IS_SCENE_DIRTY,
                result: events.invoke('scene.dirty') as boolean
            };
            source.postMessage(response, event.origin);
        }
    };

    window.addEventListener('message', onMessage);

    const dispose = () => {
        window.removeEventListener('message', onMessage);
        (events as any)._iframeApiDispose = undefined;
    };

    (events as any)._iframeApiDispose = dispose;
    return dispose;
};

export { registerIframeApi };
